// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.saleReport_wrapper__7yRn0 {
	display: grid;
	grid-template-columns: 2fr 3fr 2fr;
	font-size: 12px;
	padding: 10px 0;
	width: 1000px;
	max-width: 90%;
	margin: 0 auto;
	grid-auto-rows: minmax(70px, auto);
}

.saleReport_wrapper__7yRn0 > div {
	padding: 0.6em;
}

.saleReport_box1__8BiCf {
	grid-column: 1;
	grid-row: 1;
	display: flex;
	align-items: center;
	justify-content: center;
}

.saleReport_box2__a70bh {
	grid-column: 2;
	grid-row: 1;
	text-align: center;
}

.saleReport_box3__8YXSs {
	grid-column: 3;
	grid-row: 1;
	display: flex;
	align-items: center;
	justify-content: center;
}

.saleReport_box4__\\+z9\\+y {
	grid-column: 1/4;
	grid-row: 2;
	text-align: center;
}

.saleReport_box5__kODDt {
	grid-column: 1/2;
	grid-row: 3;
}

.saleReport_box6__DjkiS {
	grid-column: 3/4;
	grid-row: 3;
}

.saleReport_box7__SPdra {
	justify-content: stretch;
	grid-column: 1/4;
	grid-row: 4;
}

.saleReport_box8__OnYHw {
	grid-column: 1/2;
	grid-row: 6;
}

.saleReport_box9__OMxk\\+ {
	grid-column: 3/4;
	grid-row: 5;
}

.saleReport_box10__d9VX8 {
	grid-column: 3/4;
	grid-row: 10;
}

.saleReport_box11__UOqiV {
	grid-column: 1/2;
	grid-row: 10;
}

.saleReport_box12__wRM2x {
	grid-column: 1/4;
	grid-row: 11;
	text-align: center;
}

.saleReport_box13__TcaQQ {
	grid-column: 1/3;
	grid-row: 5;
}

.saleReport_box14__MVf0r {
	grid-column: 1/4;
	grid-row: 7;
}

.saleReport_footer__OQEdN {
	position: fixed;
	left: 180;
	bottom: 0;
	text-align: center;
	width: 1000px;
	max-width: 90%;
}

body {
	font-family: "Inter", sans-serif;
}
table {
	width: 100%;
	border-collapse: collapse;
}
table.saleReport_table1__YgItX,
table.saleReport_table1__YgItX th,
table.saleReport_table1__YgItX td {
	border: 1px solid silver;
}
table.saleReport_table1__YgItX th,
table.saleReport_table1__YgItX td {
	text-align: left;
	padding: 5px;
}
table.saleReport_table1__YgItX tr:nth-child(even) {
	background-color: #f2f2f2;
}

table.saleReport_table2__ytxF\\+ {
	border-collapse: collapse;
	width: 100%;
}

table.saleReport_table2__ytxF\\+ th,
table.saleReport_table2__ytxF\\+ td {
	padding: 8px;
	text-align: left;
	border-bottom: 1px solid #ddd;
}
hr.saleReport_hr1__12RUq {
	border-top: 1px dotted rgb(63, 63, 63);
}

.saleReport_button-size__TOLFs {
	padding: 8px;
	margin-top: -4px !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/Invoice/saleReport.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,kCAAkC;CAClC,eAAe;CACf,eAAe;CACf,aAAa;CACb,cAAc;CACd,cAAc;CACd,kCAAkC;AACnC;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,cAAc;CACd,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,wBAAwB;CACxB,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,SAAS;CACT,SAAS;CACT,kBAAkB;CAClB,aAAa;CACb,cAAc;AACf;;AAEA;CACC,gCAAgC;AACjC;AACA;CACC,WAAW;CACX,yBAAyB;AAC1B;AACA;;;CAGC,wBAAwB;AACzB;AACA;;CAEC,gBAAgB;CAChB,YAAY;AACb;AACA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;;CAEC,YAAY;CACZ,gBAAgB;CAChB,6BAA6B;AAC9B;AACA;CACC,sCAAsC;AACvC;;AAEA;CACC,YAAY;CACZ,2BAA2B;AAC5B","sourcesContent":[".wrapper {\n\tdisplay: grid;\n\tgrid-template-columns: 2fr 3fr 2fr;\n\tfont-size: 12px;\n\tpadding: 10px 0;\n\twidth: 1000px;\n\tmax-width: 90%;\n\tmargin: 0 auto;\n\tgrid-auto-rows: minmax(70px, auto);\n}\n\n.wrapper > div {\n\tpadding: 0.6em;\n}\n\n.box1 {\n\tgrid-column: 1;\n\tgrid-row: 1;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.box2 {\n\tgrid-column: 2;\n\tgrid-row: 1;\n\ttext-align: center;\n}\n\n.box3 {\n\tgrid-column: 3;\n\tgrid-row: 1;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.box4 {\n\tgrid-column: 1/4;\n\tgrid-row: 2;\n\ttext-align: center;\n}\n\n.box5 {\n\tgrid-column: 1/2;\n\tgrid-row: 3;\n}\n\n.box6 {\n\tgrid-column: 3/4;\n\tgrid-row: 3;\n}\n\n.box7 {\n\tjustify-content: stretch;\n\tgrid-column: 1/4;\n\tgrid-row: 4;\n}\n\n.box8 {\n\tgrid-column: 1/2;\n\tgrid-row: 6;\n}\n\n.box9 {\n\tgrid-column: 3/4;\n\tgrid-row: 5;\n}\n\n.box10 {\n\tgrid-column: 3/4;\n\tgrid-row: 10;\n}\n\n.box11 {\n\tgrid-column: 1/2;\n\tgrid-row: 10;\n}\n\n.box12 {\n\tgrid-column: 1/4;\n\tgrid-row: 11;\n\ttext-align: center;\n}\n\n.box13 {\n\tgrid-column: 1/3;\n\tgrid-row: 5;\n}\n\n.box14 {\n\tgrid-column: 1/4;\n\tgrid-row: 7;\n}\n\n.footer {\n\tposition: fixed;\n\tleft: 180;\n\tbottom: 0;\n\ttext-align: center;\n\twidth: 1000px;\n\tmax-width: 90%;\n}\n\nbody {\n\tfont-family: \"Inter\", sans-serif;\n}\ntable {\n\twidth: 100%;\n\tborder-collapse: collapse;\n}\ntable.table1,\ntable.table1 th,\ntable.table1 td {\n\tborder: 1px solid silver;\n}\ntable.table1 th,\ntable.table1 td {\n\ttext-align: left;\n\tpadding: 5px;\n}\ntable.table1 tr:nth-child(even) {\n\tbackground-color: #f2f2f2;\n}\n\ntable.table2 {\n\tborder-collapse: collapse;\n\twidth: 100%;\n}\n\ntable.table2 th,\ntable.table2 td {\n\tpadding: 8px;\n\ttext-align: left;\n\tborder-bottom: 1px solid #ddd;\n}\nhr.hr1 {\n\tborder-top: 1px dotted rgb(63, 63, 63);\n}\n\n.button-size {\n\tpadding: 8px;\n\tmargin-top: -4px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `saleReport_wrapper__7yRn0`,
	"box1": `saleReport_box1__8BiCf`,
	"box2": `saleReport_box2__a70bh`,
	"box3": `saleReport_box3__8YXSs`,
	"box4": `saleReport_box4__+z9+y`,
	"box5": `saleReport_box5__kODDt`,
	"box6": `saleReport_box6__DjkiS`,
	"box7": `saleReport_box7__SPdra`,
	"box8": `saleReport_box8__OnYHw`,
	"box9": `saleReport_box9__OMxk+`,
	"box10": `saleReport_box10__d9VX8`,
	"box11": `saleReport_box11__UOqiV`,
	"box12": `saleReport_box12__wRM2x`,
	"box13": `saleReport_box13__TcaQQ`,
	"box14": `saleReport_box14__MVf0r`,
	"footer": `saleReport_footer__OQEdN`,
	"table1": `saleReport_table1__YgItX`,
	"table2": `saleReport_table2__ytxF+`,
	"hr1": `saleReport_hr1__12RUq`,
	"button-size": `saleReport_button-size__TOLFs`
};
export default ___CSS_LOADER_EXPORT___;
